import { BaseClient } from '../client';
import { GroupDealerMock } from './groupDealer.mocks';
import { TGrupoConcessionaria } from './groupDealer.types';

interface getDealerByIdProps {
	id: string;
}

export const getGroupDealerById = async ({ id }: getDealerByIdProps) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return GroupDealerMock;
	// }

	try {
		const response = await BaseClient.get<TGrupoConcessionaria>(`/GrupoConcessionarias/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
